"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isApiModule = void 0;
var ModuleType_1 = require("./ModuleType");
/**
 * Verify if the provided class is a api type.
 * Should be used as a Typescript type-guard
 *
 * @example
 * ```
 * if(isApiModule(module)){
 *  // module is types as ApiModule here
 * }
 * ```
 */
var isApiModule = function (moralisClass) {
    if (moralisClass.type === ModuleType_1.ModuleType.API) {
        return true;
    }
    return false;
};
exports.isApiModule = isApiModule;
//# sourceMappingURL=utils.js.map